module.exports = __webpack_public_path__ + "static/media/Santa Rosa Avenue, Santa Barbara, CA4.32f57fa0.jpg";